import axios from "axios";
import tokenInterceptor from "$api/tokenInterceptor";

export let client;

export const configureClient = (url) => {
  client = axios.create({
    baseURL: url,
  });

  // add token to all requests
  client.interceptors.request.use(tokenInterceptor);
};
